;(function () {
  angular
    .module('contrast.org.vulnerabilities')
    .controller('ModalTagTracesCtrl', ModalTagTracesCtrl)

  function ModalTagTracesCtrl(
    $scope,
    $routeParams,
    $uibModalInstance,
    logger,
    TagFactory,
    TagService,
    ErrorService,
    traces,
    title
  ) {
    'ngInject'

    var originalTags = [],
      _appId = $routeParams.appId,
      _serverId = $routeParams.serverId

    angular.extend($scope, {
      traces: traces,
      title: title,
      taggingLabel: TagService.getTaggingLabel(),
      model: {
        tags: []
      },
      tracetags: {}
    })

    angular.extend($scope, {
      ok: ok,
      cancel: cancel,
      hasAvailableTags: hasAvailableTags,
      onTaggingSelect: TagService.onTaggingSelect.bind($scope, 'model.tags')
    })

    function init() {
      getAvailableTags().then(function (response) {
        $scope.availableTags = response.data.tags
      }, processError)

      TagFactory.getTracesTagsBulk(traces).then(function (response) {
        if (response.data.tags) {
          originalTags = response.data.tags
          $scope.model.tags = response.data.tags
          $scope.has_tags = originalTags.length > 0
          $scope.bulk_operation = $scope.has_tags && traces.length > 1
        }
      }, processError)
    }

    function getAvailableTags() {
      if (_appId) {
        return TagFactory.getTraceTagsByApplication(_appId)
      } else if (_serverId) {
        return TagFactory.getTraceTagsByServer(_serverId)
      }
      return TagFactory.getTraceTagsByOrganization()
    }

    function ok() {
      TagFactory.tagTracesBulk({
        traces_uuid: traces,
        tags: $scope.model.tags,
        tags_remove: _.difference(originalTags, $scope.model.tags)
      })
        .then(function (response) {
          logger.logSuccess(response.data.messages[0])
          $uibModalInstance.close()
        })
        .catch(processError)
    }

    function cancel() {
      $uibModalInstance.dismiss('cancel')
    }

    function processError(response) {
      ErrorService.processError(response)
      $uibModalInstance.close()
    }

    function hasAvailableTags() {
      return (
        !$scope.has_tags &&
        $scope.model.tags &&
        $scope.model.tags.length == 0 &&
        $scope.availableTags &&
        $scope.availableTags.length == 0
      )
    }

    init()
  }
})()
